import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HashRouter as Router, Switch, Redirect, Route, withRouter } from 'react-router-dom';

import Page from './modules/page/page';
import Cards from './modules/cards/cards';
import Index from './modules/index/index';
import Menu from './modules/menu/menu';

class ScrollToTop extends Component {
    componentDidUpdate(previousProps) {
        if (this.props.location !== previousProps.location) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children || null;
    }
}

ScrollToTop.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
};

ScrollToTop.defaultProps = {
    children: null,
    location: {}
};

const ScrollToTopWithRouter = withRouter(ScrollToTop);

class App extends React.Component {
    render() {
        return (
            <Router>
                <ScrollToTopWithRouter />
                <Switch>
                    <div className="container__content">
                        <Route exact path="/" render={() => <Redirect to="/index" />} />
                        <Route
                            path="/page/:pk"
                            render={({ match }) => <Page pk={match.params.pk} />}
                        />
                        <Route component={Menu} path="/menu" />
                        <Route component={Index} path="/index" />
                        <Route component={Cards} path="/cards" />
                    </div>
                </Switch>
            </Router>
        );
    }
}

export default App;
